/**
 * @generated SignedSource<<e88c98c9507e2d129b9f792a9d4a9196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Project_userProfile$data = {
  readonly analyticsId: number;
  readonly avatarImage: {
    readonly id: string;
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly lastName: string | null;
  readonly professionalTitle: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPartnerWithAction_userProfile">;
  readonly " $fragmentType": "Project_userProfile";
};
export type Project_userProfile$key = {
  readonly " $data"?: Project_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Project_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Project_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "professionalTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectPartnerWithAction_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "c3b98482ab1c369dd7d81a13c18be72e";

export default node;
